/**
 * 토스트 얼럿 아이콘 구분
 * @description
 */
export enum TOAST_TYPE {
  NOTICE = 'notice',
  CHECK = 'check',
  WARNING = 'warning',
}

/**
 * 운행 타입
 * @description 001 등원, 002 하원
 */
export enum ROUTE_NAME {
  PICKUP = '001', // 등원
  DROPOFF = '002', // 하원
}

/**
 * 배열 위치
 * @description
 */
export enum ARRAY_POSITION {
  FIRST = 'first',
  LAST = 'last',
}

/**
 * 날짜 비교 상태
 * @description
 */
export enum DATE_COMPARE_STATUS {
  FUTURE = 'FUTURE',
  PAST = 'PAST',
  TODAY = 'TODAY',
}
/**
 * 캠퍼스 구분
 * @description
 */
export enum CAMP_TYPE {
  CHOISUN = '001',
  MATA = '002',
  CREO = '004',
}
